import { connect } from "react-redux";
import SimuladorVenda from "./simulador";

export default connect()(SimuladorVenda);
